import { FETCH_CLIENTS, ADD_CLIENT, RESET_CLIENTS } from '../actionTypes';

const initialState = {
  data: {},
  isLoadMore: false,
  info: {}
};

export default function(state = initialState, action=null){
  switch (action.type) {
    case ADD_CLIENT:
      return {
        ...state,
        [action.payload._id]: {...action.payload}
      }
    case FETCH_CLIENTS:
      let isLoadMore = true;
      if (Object.keys(action.payload).length < 10) {
        isLoadMore = false;
      }
      return {
        ...state,
        data: {...state.data, ...action.payload},
        isLoadMore: isLoadMore
      }
    case RESET_CLIENTS:
      return initialState
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/clients.js